import { Link } from 'react-router-dom';
import { Compass } from 'lucide-react';
import { Button } from '@/components/ui/Button';

export default function NotFound() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-surface-subtle text-center px-6">
      <div className="w-14 h-14 flex items-center justify-center rounded-2xl bg-primary-50 text-primary-800">
        <Compass className="w-6 h-6" />
      </div>
      <h1 className="text-[22px] font-bold text-ink">Page not found</h1>
      <p className="text-[13.5px] text-ink-faint max-w-xs">The page you're looking for doesn't exist or you don't have access to it.</p>
      <Link to="/admin">
        <Button>Back to Home</Button>
      </Link>
    </div>
  );
}
